/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterDraftFixedAssetDetailResponse,
  PresenterDraftFixedAssetListResponse,
  PresenterError,
  PresenterExpenseDetailResponse,
  PresenterExpenseFilterResponse,
  PresenterExpenseListResponse,
  PresenterExpenseResponse,
  PresenterIDResponse,
  PresenterImportStartDateResponse,
  PresenterResponse,
  PresenterSaveImportStartDateRequest,
  PresenterSusJournalBranchSideDetailResponse,
  PresenterSusJournalListResponse,
  PresenterSusJournalRefreshResponse,
  PresenterUpsertExpenseRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SuspenseAccount<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Returns the office's draft fixed assets filtered by status. Columns mirror the FA-ledger view (horizontally scrollable per Figma). Total count is returned in meta.total; total_unreflect (office-wide NotReflected count) is returned in meta.total_unreflect.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountDraftAssets
   * @summary List draft fixed assets
   * @request GET:/suspense_account/draft_assets
   */
  getSuspenseAccountDraftAssets = (
    query?: {
      /** Draft status: 1=NotReflected (default), 2=Reflected, 3=DeletedFromLedger */
      status?: number;
      /** Asset-name substring match */
      name?: string;
      /** Filter by asset category */
      asset_category_id?: number;
      /** Filter by department BIID */
      department_biid?: string;
      /** Filter by area BIID */
      area_biid?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default 50) */
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the office-scoped draft FA with status=NotReflected
   *
   * @tags suspense_account
   * @name GetSuspenseAccountDraftAssetsById
   * @summary Get draft fixed asset detail
   * @request GET:/suspense_account/draft_assets/{id}
   */
  getSuspenseAccountDraftAssetsById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the office's expenses (status omitted = all), filterable by keyword (No./摘要), term_month_id, and the Transfer-To / Transfer-From master ids (single id each, AND-combined). Each row is a full mirror of the expense entity (+ resolved account/sub/department code+name) with its linked source sides nested under journal_allocations[].side (which in turn nests its owning branch under side.branch, and that branch's journal header under side.branch.sus_journal). Total in meta.total.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpenses
   * @summary List expense targets (費用化対象)
   * @request GET:/suspense_account/expenses
   */
  getSuspenseAccountExpenses = (
    query?: {
      /** Status filter (1=未確定, 2=確定済; omitted = all) */
      status?: number;
      /** Free-text match against 摘要 (remark) */
      keyword?: string;
      /** Term-month id filter (omitted = all term months) */
      term_month_id?: number;
      /** Transfer-To account item id filter */
      transfer_to_account_item_id?: number;
      /** Transfer-To account sub item id filter */
      transfer_to_account_sub_item_id?: number;
      /** Transfer-To department biid filter */
      transfer_to_department_biid?: string;
      /** Transfer-From (linked side) account item id filter */
      transfer_from_account_item_id?: number;
      /** Transfer-From (linked side) sub item id filter */
      transfer_from_sub_item_id?: number;
      /** Transfer-From (linked side) AccPlus dept id filter */
      transfer_from_dept_id?: number;
      /** Page number (1-based) */
      "page[number]"?: number;
      /** Page size */
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Organizes one or more suspense-journal sides as a single expense (合算 supported). Status 未確定.
   *
   * @tags suspense_account
   * @name PostSuspenseAccountExpenses
   * @summary Create an expense target (費用化対象)
   * @request POST:/suspense_account/expenses
   */
  postSuspenseAccountExpenses = (
    body: PresenterUpsertExpenseRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the distinct master values present across the office's expenses, resolved to {id, code, name} (for FE filter binding).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpensesFilters
   * @summary Expense filter values
   * @request GET:/suspense_account/expenses/filters
   */
  getSuspenseAccountExpensesFilters = (
    query?: {
      /** Status scope (1=未確定, 2=確定済; omitted = all) */
      status?: number;
      /** Term-month id scope (omitted = all term months) */
      term_month_id?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseFilterResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/filters`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a full mirror of the expense entity (+ resolved account/sub/department code+name) with its linked source sides nested under journal_allocations[].side (which in turn nests its owning branch under side.branch, and that branch's journal header under side.branch.sus_journal), and an editable flag (false when the month is closed).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountExpensesById
   * @summary Get an expense target (edit screen)
   * @request GET:/suspense_account/expenses/{id}
   */
  getSuspenseAccountExpensesById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Updates the header and/or the linked allocation set. Editing a 確定済 expense resets it to 未確定.
   *
   * @tags suspense_account
   * @name PutSuspenseAccountExpensesById
   * @summary Update an expense target
   * @request PUT:/suspense_account/expenses/{id}
   */
  putSuspenseAccountExpensesById = (
    id: number,
    body: PresenterUpsertExpenseRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterExpenseResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reverts every linked allocation (restoring source-side unprocessed amount) and deletes the expense.
   *
   * @tags suspense_account
   * @name DeleteSuspenseAccountExpensesById
   * @summary Delete an expense target
   * @request DELETE:/suspense_account/expenses/{id}
   */
  deleteSuspenseAccountExpensesById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/expenses/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * @description Returns all already-imported AccPlus journal branch sides for the office. selected_month is optional: when provided it acts as a month guard against the current monthly closing (future months return 400; past months return empty); when omitted the endpoint returns everything for the office (subject to paging and journal_ids). last_fetched_at is included so the FE can render the "最終取得日時" label. Each side carries account_item_id / account_sub_item_id (AccPlus account/sub-account IDs) alongside account_name / account_code / sub_account_name / sub_account_code. dept_name / dept_code are the AccPlus department (resolved from AccPlus by dept_id); aa_dept_biid / aa_dept_code / aa_dept_name are the mapped AA department (resolved from the local departments table via ref_id = dept_id). Both are omitted when the side has no dept or no matching department is found.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSides
   * @summary List suspense-account journals
   * @request GET:/suspense_account/journal_branch_sides
   */
  getSuspenseAccountJournalBranchSides = (
    query?: {
      /** Optional month guard, YYYY-MM; omit to return all */
      selected_month?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default/max 2000) */
      "page[size]"?: number;
      /** Optional sus_journal IDs filter; omit to return all */
      journal_ids?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the side aggregate and all active allocations owned by the side.
   *
   * @tags suspense_account
   * @name GetSuspenseAccountJournalBranchSidesById
   * @summary Get journal branch side detail with allocations
   * @request GET:/suspense_account/journal_branch_sides/{id}
   */
  getSuspenseAccountJournalBranchSidesById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalBranchSideDetailResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags suspense_account
   * @name PutSuspenseAccountJournalBranchSidesByIdDismissAlert
   * @summary Dismiss alert for a journal branch side
   * @request PUT:/suspense_account/journal_branch_sides/{id}/dismiss_alert
   */
  putSuspenseAccountJournalBranchSidesByIdDismissAlert = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/suspense_account/journal_branch_sides/${id}/dismiss_alert`,
      method: "PUT",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh suspense-account journals from AccPlus
   *
   * @tags suspense_account
   * @name PostSuspenseAccountJournalsRefresh
   * @summary Refresh suspense-account journals from AccPlus
   * @request POST:/suspense_account/journals/refresh
   */
  postSuspenseAccountJournalsRefresh = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalRefreshResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journals/refresh`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the current office's import settings (import_start_date).
   *
   * @tags suspense_account
   * @name GetSuspenseAccountSettingsImportStartDate
   * @summary Get suspense-account import settings
   * @request GET:/suspense_account/settings/import_start_date
   */
  getSuspenseAccountSettingsImportStartDate = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upsert the office's import_start_date. Returns the persisted setting.
   *
   * @tags suspense_account
   * @name PostSuspenseAccountSettingsImportStartDate
   * @summary Save suspense-account import start date
   * @request POST:/suspense_account/settings/import_start_date
   */
  postSuspenseAccountSettingsImportStartDate = (
    body: PresenterSaveImportStartDateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
